// extracted by mini-css-extract-plugin
export default {"header":"header_header__-oU1P"};